import { useGAPageViews } from '@dx-ui/dx-common';
import { ShowContext, useShowController } from 'react-admin';
import OrderShowView from './OrderShowView';

const OrderShow = (props) => {
  useGAPageViews();
  const controllerProps = useShowController(props);
  return (
    <ShowContext.Provider value={controllerProps}>
      <OrderShowView controllerProps={controllerProps} {...props} />
    </ShowContext.Provider>
  );
};

export default OrderShow;
